import React, { useMemo, Suspense, useCallback } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Circles } from "react-loader-spinner";
import CryptoJS from "crypto-js";
import getDecryptedToken from "./api/getDecryptedToken";
import PayhereSucces from "./pages/payhere/PayhereSucces";
import PayhereCancel from "./pages/payhere/PayhereCancel";
import PaymentData from "./views/paymentView/PaymentData";
import Layouts from "./layouts/layoutnew/Layouts";
import { NEWROUTES } from "./utils/routes/new.routes";
import { renderRoutes } from "./utils/routing/renderRoutes";
import Drlogin from "./views/maillogin/Drlogin";
import NextQueue from "./pages/nextQueue/NextQueue";
const Login = React.lazy(() => import("./views/login/Login"));
const Bill = React.lazy(() => import("./views/bill/Bill"));

const Printtest = React.lazy(
  () => import("./pages/setting/manageprint/ManagePrint")
);
const routePermission: string | null = localStorage.getItem("routePermission");
let permissionRoutes: number[] | undefined;
if (routePermission) {
  try {
    permissionRoutes = CryptoJS.AES.decrypt(
      routePermission,
      process.env.REACT_APP_SECRET || "sfdsfasdfsdf3434$$$"
    )
      .toString(CryptoJS.enc.Utf8)
      .split(",")
      .map(Number);
  } catch (error) {
    console.error("Error decrypting routePermission:", error);
  }
}
const decrypteduser: string | undefined = getDecryptedToken("user");
function App() {
  const filterByIds = useCallback((array: any, ids: any) => {
    return array?.reduce((filtered: any, item: any) => {
      // Check both accessRoute.KEY (for ALLROUTES) and KEY (for NEWROUTES)
      const itemKey = item?.accessRoute?.KEY || item?.KEY;
      if (ids?.includes(itemKey)) {
        const newItem = { ...item };
        // Handle both subnav (lowercase for ALLROUTES) and SUBNAV (uppercase for NEWROUTES)
        if (item.subnav) {
          newItem.subnav = filterByIds(item?.subnav, ids);
        }
        if (item.SUBNAV) {
          newItem.SUBNAV = filterByIds(item?.SUBNAV, ids);
        }
        filtered.push(newItem);
      }
      return filtered;
    }, []);
  }, []);



  const filteredNewRoutes = useMemo(
    () => filterByIds(NEWROUTES, permissionRoutes),
    [filterByIds]
  );

  return (
    <>
      <BrowserRouter>
        <Suspense
          fallback={
            <Circles
              height="80"
              width="80"
              color="#174d7a"
              ariaLabel="bars-loading"
              wrapperStyle={{
                position: "fixed",
                inset: "0",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              wrapperClass=""
            />
          }
        >
          <Routes>
            <Route path="/print/:ID" element={<Printtest />} />
            <Route path="/invoice" element={<Bill />} />
            <Route path="/login" element={<Drlogin />} />
            <Route path="/drlogin" element={<Login />} />
            {/* Patient queue display (wall / TV): static paths must be listed before /room/:roomId */}
            <Route path="/room" element={<NextQueue />} />
            <Route path="/room/all" element={<NextQueue />} />
            <Route path="/room/custom" element={<NextQueue />} />
            <Route path="/room/:roomId" element={<NextQueue />} />
            {decrypteduser === "client" && (
              <>
              <Route path="/" element={<Navigate to="/client" />} />
                <Route
                  path="/client"
                  element={<Layouts routes={filteredNewRoutes} />}
                >
                  <Route path="/client" element={<Navigate to="dashboard" />} />
                  {renderRoutes(filteredNewRoutes, "/client/")}
                </Route>
                <Route path="/client/pay" element={<PaymentData />} />
                <Route
                  path="/client/payment/success"
                  element={<PayhereSucces />}
                />
                <Route
                  path="/client/payment/cancel"
                  element={<PayhereCancel />}
                />
              </>
            )}
      
          

            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
}

export default App;
